import { render, staticRenderFns } from "./CampaignDropdown.vue?vue&type=template&id=1974b18e&scoped=true"
import script from "./CampaignDropdown.vue?vue&type=script&lang=js"
export * from "./CampaignDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974b18e",
  null
  
)

export default component.exports